module.exports = __webpack_public_path__ + "img/solarpannel.994d75cb.svg";